import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import { SCROLL_IMAGES } from "../../data/content";
import { Reveal } from "../shared";

export default function ImageScroll() {
  const ref = useRef(null);
  const trackRef = useRef(null);
  const [range, setRange] = useState(0);

  useEffect(() => {
    const measure = () => {
      if (trackRef.current) setRange(Math.max(0, trackRef.current.scrollWidth - window.innerWidth + 48));
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], [0, -range]);

  return (
    <section ref={ref} className="relative bg-ink" style={{ height: "340vh" }} data-testid="image-scroll-gallery">
      <div className="sticky top-0 flex h-screen flex-col justify-center overflow-hidden">
        <div className="flex items-end justify-between px-6 pb-8 md:px-16">
          <Reveal>
            <p className="flex items-center gap-4 text-gold-light">
              <span className="font-serif italic text-xl">01</span>
              <span className="h-px w-12 bg-gold/60" />
              <span className="text-[11px] md:text-xs font-medium uppercase tracking-[0.28em]">Into Our World</span>
            </p>
            <h2 className="mt-4 font-serif text-4xl md:text-6xl text-ivory leading-tight">This is how it feels<br />to celebrate with us</h2>
          </Reveal>
          <p className="hidden md:block max-w-xs text-right text-xs leading-relaxed text-ivory/50">Haldi · Weddings · Sangeet · Sufi Nights · Beach &amp; River Celebrations · The details in between</p>
        </div>

        <motion.div ref={trackRef} style={{ x }} className="flex w-max items-end gap-5 px-6 md:gap-8 md:px-16">
          {SCROLL_IMAGES.map((im, i) => (
            <Link
              key={i}
              to={im.to || "/gallery"}
              data-testid={`scroll-image-${i}`}
              className={`group relative overflow-hidden ${im.tall ? "h-[340px] w-[250px] md:h-[540px] md:w-[380px]" : "h-[300px] w-[230px] md:h-[440px] md:w-[330px]"} shrink-0`}
            >
              <img src={im.src} alt={im.label} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent opacity-70" />
              <figcaption className="absolute bottom-4 left-4 right-4">
                <span className="text-[10px] uppercase tracking-[0.25em] text-gold-light">{String(i + 1).padStart(2, "0")}</span>
                <p className="font-serif text-xl md:text-2xl italic text-ivory">{im.label}</p>
              </figcaption>
            </Link>
          ))}
          <div className="flex h-[300px] w-[230px] md:h-[440px] md:w-[330px] shrink-0 flex-col items-center justify-center gap-6 border border-gold/30 text-center">
            <p className="font-serif text-2xl italic text-ivory">And hundreds<br />more…</p>
            <Link to="/gallery" data-testid="scroll-gallery-view-all" className="inline-flex rounded-full border border-gold/60 px-7 py-3.5 text-[11px] uppercase tracking-[0.22em] text-gold-light transition-all duration-500 hover:bg-gold hover:text-ink">
              View Full Gallery
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
